// 补充rem相关配置，所有屏幕宽度为100% = 750px = 7.5rem, 相当于原先的100px写成rem后是1rem

let firstRun = true;
let timeHandle: any;
function handleResize() {
  clearTimeout(timeHandle);
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  timeHandle = setTimeout(initREM, 100);
}

function initREM(): void {
  if (firstRun) {
    window.addEventListener('resize', handleResize);
    firstRun = false;
  }
  const html = document.documentElement;
  let { width } = html.getBoundingClientRect();
  // 这里不用document.body.clientWidth的原因是不知道为啥会计算375的屏幕为359， 而html.getBoundingClientRect不会
  width = Math.round(width);
  width = width > 750 ? 750 : width;
  const r = (width / 750) * 100;
  document.documentElement.style.fontSize = `${r}px`;
}

export default initREM;
